
import React from 'react';
import AppLayout from '@/components/AppLayout';
import { AppProvider } from '@/contexts/AppContext';
import AppBootErrorBoundary from '@/components/AppBootErrorBoundary';

/**
 * Index page — wraps AppLayout in:
 *   1. AppBootErrorBoundary: catches any render-error escaping from the
 *      authenticated dashboard subtree (FamilyProvider, FamilyGraphSection,
 *      ResilienceMonitor, QuickAddModal, etc.) and shows the universal
 *      "We're reconnecting your family access" recovery screen with
 *      "Retry connection" + "Return to invite / join family" buttons —
 *      so an invited member, unpaid user, or pending account can never
 *      land on a blank/non-loading page.
 *   2. AppProvider: the existing legacy AppContext (kept untouched).
 *
 * The boundary lives OUTSIDE of AppProvider on purpose: if AppProvider
 * itself ever throws on mount, the boundary still has a chance to render
 * the recovery UI instead of a white screen.
 */
const Index: React.FC = () => {
  return (
    <AppBootErrorBoundary>
      <AppProvider>
        <AppLayout />
      </AppProvider>
    </AppBootErrorBoundary>
  );
};

export default Index;
